// client/src/components/TiptapEditor/TiptapEditor.js
import React, { useEffect } from "react";
import { useEditor, EditorContent } from "@tiptap/react";

// Extensiones Principales
import StarterKit from "@tiptap/starter-kit";
import { Color } from "@tiptap/extension-color";
import TextStyle from "@tiptap/extension-text-style";
import FontFamily from "@tiptap/extension-font-family";
import Highlight from "@tiptap/extension-highlight";
import Image from "@tiptap/extension-image";
import Link from "@tiptap/extension-link";
import Placeholder from "@tiptap/extension-placeholder";
import Table from "@tiptap/extension-table";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import TableRow from "@tiptap/extension-table-row";
import TextAlign from "@tiptap/extension-text-align";
import Underline from "@tiptap/extension-underline";
import { FontSize } from "./extensions/FontSize";
import Subscript from "@tiptap/extension-subscript";
import Superscript from "@tiptap/extension-superscript";

// UI
import { MenuBar } from "./MenuBar";
import "./TiptapEditor.scss";

// Atajos de teclado opcionales para super/sub
const SuperscriptKbd = Superscript.extend({
  addKeyboardShortcuts() {
    return { "Mod-.": () => this.editor.commands.toggleSuperscript() };
  },
});
const SubscriptKbd = Subscript.extend({
  addKeyboardShortcuts() {
    return { "Mod-,": () => this.editor.commands.toggleSubscript() };
  },
});

// Helper para configurar extensiones
const cfg = (Ext, opts = {}) =>
  typeof Ext?.configure === "function" ? Ext.configure(opts) : Ext;

// ⬇️ onChange con no-op por defecto + className opcional
export const TiptapEditor = ({
  content = "",
  onChange = () => {},
  className,
}) => {
  const editor = useEditor({
    extensions: [
      cfg(StarterKit, {
        table: false,
        heading: { levels: [1, 2, 3], marks: true },
      }),
      // Marcas y estilos
      Underline,
      Highlight,
      TextStyle,
      Color,
      FontFamily,
      FontSize,
      // Nodos de bloque
      Image,
      cfg(Table, { resizable: true }),
      TableRow,
      TableHeader,
      TableCell,
      SuperscriptKbd,
      SubscriptKbd,
      // Otras funcionalidades
      cfg(Link, { openOnClick: true, autolink: true }),
      cfg(TextAlign, { types: ["heading", "paragraph"] }),
      cfg(Placeholder, { placeholder: "Empieza a escribir aquí…" }),
    ],
    content,

    // Llama a onChange SOLO si es una función
    onUpdate: ({ editor: ed }) => {
      const html = ed.getHTML();
      if (typeof onChange === "function") onChange(html);
    },
  });

  // Sincroniza si content cambia desde fuera
  useEffect(() => {
    if (editor && typeof content === "string" && editor.getHTML() !== content) {
      editor.commands.setContent(content, false);
    }
  }, [content, editor]);

  if (!editor) return null;

  return (
    <div className={`tiptap-editor-container ${className || ""}`}>
      <MenuBar editor={editor} />
      <EditorContent editor={editor} />
    </div>
  );
};
